import api from '@/services/api';

export default {
  getFinances: ({ commit }, params) => {
    api.getFinances(params).then((response) => {
      let finances = response.data.data;

      finances = finances.map((item) => ({
        ...item,
        saldo: 0,
      }));
      commit('INIT_FINANCES', finances);
    });
  },
  getFinanceInfo: ({ commit }, props) => {
    api.getFinanceInfo(props).then((response) => {
      commit('INIT_FINANCE_INFO', response.data.data);
    });
  },
  getCompanies: ({ commit }, props) => {
    api.getCompanies(props).then((response) => {
      commit('INIT_COMPANIES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  // eslint-disable-next-line
  getCompany: ({ commit }, payload) => {
    return api.getCompanyById(payload).then((response) => {
      commit('SELECT_COMPANY', response.data.data);
    });
  },
  getCommercialists: ({ commit }) => {
    api.getCommercialists().then((response) => {
      commit('INIT_COMMERCIALISTS', response.data.data);
    });
  },
  getTowns: ({ commit }, payload) => {
    api.getTowns(payload).then((response) => {
      commit('INIT_TOWNS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getTown: ({ commit }, id) => {
    api.getTown(id).then((response) => {
      commit('INIT_TOWN', response.data.data);
    });
  },
  getShippingTowns: ({ commit }, payload) => {
    api.getTowns(payload).then((response) => {
      commit('INIT_SHIPPING_TOWNS', response.data.data);
    });
  },
  getUsers: ({ commit }, payload) => {
    api.getUsers(payload).then((response) => {
      commit('INIT_USERS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  // eslint-disable-next-line
  getUser: ({ commit }, id) => {
    return api.getUserById(id).then((response) => {
      commit('SELECT_USER', response.data.data);
    });
  },
  // eslint-disable-next-line
  getShippingInfoForUser: ({ commit }, id) => {
    return api.getShippingInfoForUserById(id).then((response) => {
      commit('SELECT_USER_SHIPPING_INFO', response.data.data);
    });
  },
  saveToken: ({ commit }, token) => {
    localStorage.setItem('token', token);
    commit('INIT_TOKEN', token);
  },
  storeProfileData: ({ commit }, payload) => {
    commit('INIT_PROFILE_DATA', payload);
  },
  // eslint-disable-next-line
  getShippingAddresses: ({ commit }) => {
    return api.getShippingAddresses().then((response) => {
      commit('INIT_SHIPPING_ADDRESSES', response.data.data);
      return response.data.data;
    });
  },
  getShippingAddressesFiltered: ({ commit }, payload) => api.getShippingAddressesFiltered(payload)
    .then((response) => {
      commit('INIT_SHIPPING_ADDRESSES_FILTERED', response.data.data);
      return response.data;
    }),
  // eslint-disable-next-line
  getShippingAddress: ({ commit }, id) => {
    return api.getShippingAddress(id).then((response) => {
      commit('INIT_SHIPPING_ADDRESS', response.data.data);
      return response.data.data;
    });
  },

  // Countries
  getCountries: ({ commit }, props) => {
    // api.abortController.abort();
    api.getCountries(props).then((response) => {
      commit('INIT_COUNTRIES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getCountry: ({ commit }, id) => {
    api.getCountry(id).then((response) => {
      commit('INIT_COUNTRY', response.data.data);
    });
  },
  // eslint-disable-next-line
  getProfile: ({ commit }) => api.getProfile().then((response) => {
    commit('INIT_USER_PROFILE', response.data.data);
    return response.data.data;
  }),
  getCategories: ({ commit }, payload) => {
    api.getCategories(payload).then((response) => {
      commit('INIT_CATEGORIES', response.data.data);
      // commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getSimplifiedCategories: ({ commit }, payload) => {
    api.getSimplifiedCategories(payload).then((response) => {
      commit('INIT_SIMPLIFIED_CATEGORIES', response.data.data);
    });
  },
  getCategoryById: ({ commit }, payload) => {
    api.getCategoryById(payload).then((response) => {
      commit('INIT_CATEGORY', response.data.data[0]);
    });
  },
  getCategoriesFilter: ({ commit }, payload) => {
    api.getCategoriesFilter(payload).then((response) => {
      commit('INIT_CATEGORIES_FILTER', response.data.data);
    });
  },

  // Articles
  getArticles: ({ commit }, payload) => {
    api.getArticles(payload).then((response) => {
      let articles = response.data.data;

      articles = articles.map((item) => ({
        ...item,
        quantity: 1,
      }));

      commit('INIT_ARTICLES', articles);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  // eslint-disable-next-line
  getArticleById: ({ commit }, payload) => {
    return api.getArticleById(payload).then((response) => {
      commit('INIT_ARTICLE', response.data.data);
      return response.data.data;
    });
  },
  getCustomerCustomizedArticles: ({ commit }, payload) => {
    api.getCustomerCustomizedArticles(payload).then((response) => {
      let { articles } = response.data.data;
      const { filters } = response.data.data;

      articles = articles.map((item) => ({
        ...item,
        quantity: 1,
      }));

      commit('GET_CUSTOMER_ARTICLES', articles);
      commit('GET_CUSTOMER_ARTICLES_FILTER', filters);
    });
  },
  // getCustomerCustomizedArticlesFilter: ({ commit }, payload) => {
  //   api.getCustomerCustomizedArticlesFilter(payload).then((response) => {
  //     commit('GET_CUSTOMER_ARTICLES_FILTER', response.data.data);
  //   });
  // },
  getNewlyAddedArticles: ({ commit }, payload) => {
    api.getNewlyAddedArticles(payload).then((response) => {
      commit('GET_NEWLY_ADDED_ARTICLES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getNewlyAddedArticlesFilter: ({ commit }, payload) => {
    api.getNewlyAddedArticlesFilter(payload).then((response) => {
      commit('GET_NEWLY_ADDED_ARTICLES_FILTER', response.data.data);
    });
  },
  getReviewsForArticle: ({ commit }, articleId) => {
    api.getReviews(articleId).then((response) => {
      commit('INIT_REVIEWS', response.data.data);
    });
  },
  getVariationsForArticle: ({ commit }, articleId) => {
    api.getVariationsForArticle(articleId).then((response) => {
      commit('INIT_REVIEWS', response.data.data);
    });
  },
  getQuickSearch: ({ commit }, payload) => {
    api.getArticlesBySearch(payload).then((response) => {
      commit('INIT_SEARCH_ARTICLES', response.data.data);
    });
  },
  getQuickSearchArticles: ({ commit }, payload) => {
    api.getArticlesBySearch(payload).then((response) => {
      let { articles } = response.data.data;

      articles = articles.map((item) => ({
        ...item,
        quantity: 1,
      }));

      // eslint-disable-next-line no-param-reassign
      response.data.data.articles = articles;
      commit('INIT_SEARCH_VIEW_ARTICLES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getQuickSearchFilters: ({ commit }, payload) => {
    api.getSearchFilters(payload).then((response) => {
      commit('INIT_SEARCH_FILTERS', response.data.data);
    });
  },
  getQuickViewArticle: ({ commit }, articleId) => api.getQuickViewArticle(articleId)
    .then((response) => {
      commit('INIT_QUICK_ARTICLE', response.data.data);
    }),
  getRecentArticles: ({ commit }, articleIds) => {
    api.getRecentArticles(articleIds).then((response) => {
      commit('INIT_RECENT_ARTICLES', response.data.data);
    });
  },
  getMyArticles: ({ commit }, payload) => {
    api.getMyArticles(payload).then((response) => {
      const articles = response.data.data.map((item) => ({
        ...item,
        quantity: 0,
      }));

      commit('INIT_MY_ARTICLES', articles);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  // eslint-disable-next-line max-len
  getMyArticlesFilter: ({ commit }, payload) => api.getMyArticlesFilter(payload).then((response) => {
    commit('INIT_MY_ARTICLES_FILTER', response.data.data);
    return response.data.data;
  }),
  getArticlesOnSale: ({ commit }, payload) => {
    api.getArticlesOnSale(payload).then((response) => {
      commit('INIT_SALE_ARTICLES', response.data.data);
    });
  },

  // Banks
  getBanks: ({ commit }, payload) => {
    api.getBanks(payload).then((response) => {
      commit('INIT_BANKS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getBank: ({ commit }, payload) => {
    api.getBank(payload).then((response) => {
      commit('INIT_BANK', response.data.data);
    });
  },
  getCurrencies: ({ commit }, payload) => {
    api.getCurrencies(payload).then((response) => {
      commit('INIT_CURRENCIES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getCurrency: ({ commit }, payload) => {
    api.getCurrency(payload).then((response) => {
      commit('INIT_CURRENCY', response.data.data);
    });
  },
  getMeasurementUnits: ({ commit }, payload) => {
    api.getMeasurementUnits(payload).then((response) => {
      commit('INIT_MEASUREMENT_UNITS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getBrands: ({ commit }, payload) => {
    api.getBrands(payload).then((response) => {
      commit('INIT_BRANDS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getAllBrands: ({ commit }) => {
    api.getAllBrands().then((response) => {
      commit('INIT_ALL_BRANDS', response.data.data);
    });
  },
  getBrand: ({ commit }, payload) => {
    api.getBrand(payload).then((response) => {
      commit('INIT_BRAND', response.data.data);
    });
  },
  getTaxes: ({ commit }, payload) => {
    api.getTaxes(payload).then((response) => {
      commit('INIT_TAXES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getExpressPosts: ({ commit }) => {
    api.getExpressPosts().then((response) => {
      commit('INIT_EXPRESS_POSTS', response.data.data);
    });
  },
  // eslint-disable-next-line
  getExpressPost: ({ commit }, payload) => {
    return api.getExpressPost(payload).then((response) => {
      commit('INIT_EXPRESS_POST', response.data.data);
    });
  },
  getTabs: ({ commit }, payload) => {
    api.getTabs(payload).then((response) => {
      commit('INIT_TABS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getTab: ({ commit }, payload) => {
    api.getTab(payload).then((response) => {
      commit('INIT_TAB', response.data.data);
    });
  },
  // Product sales
  getProductSales: ({ commit }, payload) => {
    api.getProductSales(payload).then((response) => {
      commit('INIT_PRODUCT_SALES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getProductSale: ({ commit }, id) => {
    api.getProductSale(id).then((response) => {
      commit('INIT_PRODUCT_SALE', response.data.data);
    });
  },

  // Interests areas
  getInterestsAreas: ({ commit }, payload) => {
    api.getInterestsAreas(payload).then((response) => {
      commit('INIT_INTERESTS_AREAS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getInterestsArea: ({ commit }, id) => {
    api.getInterestsArea(id).then((response) => {
      commit('INIT_INTERESTS_AREA', response.data.data);
    });
  },

  // Customer bank accounts
  getCustomerBankAccounts: ({ commit }, payload) => {
    api.getCustomerBankAccounts(payload).then((response) => {
      commit('INIT_CUSTOMER_BANK_ACCOUNTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getCustomerBankAccount: ({ commit }, id) => {
    api.getCustomerBankAccount(id).then((response) => {
      commit('INIT_CUSTOMER_BANK_ACCOUNT', response.data.data);
    });
  },

  // Blogs
  getBlogs: ({ commit }, payload) => {
    api.getBlogs(payload).then((response) => {
      commit('INIT_BLOGS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getRecentBlogs: ({ commit }) => {
    api.getRecentBlogs().then((response) => {
      commit('INIT_RECENT_BLOGS', response.data.data);
    });
  },
  getBlog: ({ commit }, id) => {
    api.getBlog(id).then((response) => {
      commit('INIT_BLOG', response.data.data);
    });
  },

  // Terms of services
  getTermsOfServices: ({ commit }) => {
    api.getTermsOfServices().then((response) => {
      commit('INIT_TERMS_OF_SERVICES', response.data.data);
    });
  },

  // Attributes
  getAttributes: ({ commit }, payload) => {
    api.getAttributes(payload).then((response) => {
      commit('INIT_ATTRIBUTES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getAttribute: ({ commit }, id) => {
    api.getAttribute(id).then((response) => {
      commit('INIT_ATTRIBUTE', response.data.data);
    });
  },
  getAttributesByIds: ({ commit }, ids) => {
    api.getAttributesByIds(ids).then((response) => {
      commit('INIT_ATTRIBUTE_VALUES', response.data.data);
    });
  },
  getArticleVariations: ({ commit }, id) => {
    api.getArticleVariations(id).then((response) => {
      commit('INIT_ARTICLE_VARIATIONS', response.data.data);
    });
  },

  // Homepage
  getAllJumbotrons: ({ commit }) => {
    api.getAllJumbotrons().then((response) => {
      commit('INIT_JUMBOTRONS', response.data.data);
    });
  },
  getHighlightedCategories: ({ commit }) => {
    api.getHighlightedCategories().then((response) => {
      commit('INIT_HIGHLIGHTED_CATEGORIES', response.data.data);
    });
  },
  getHighlightedBrand: ({ commit }) => {
    api.getHighlightedBrand().then((response) => {
      commit('INIT_HIGHLIGHTED_BRAND', response.data.data);
    });
  },
  getTopBrands: ({ commit }) => {
    api.getTopBrands().then((response) => {
      commit('INIT_TOP_BRANDS', response.data?.data?.topBrandItems);
    });
  },
  getWishList: ({ commit }) => {
    api.getWishList().then((response) => {
      commit('INIT_WISHLIST', response.data.data);
    });
  },

  // Shopping Carts
  getShoppingCart: ({ commit }) => {
    api.getShoppingCart().then((response) => {
      commit('INIT_SHOPPING_CART', response.data.data);
    });
  },
  getShoppingCarts: ({ commit }, payload) => {
    api.getShoppingCarts(payload).then((response) => {
      commit('INIT_SHOPPING_CARTS', response.data.data ?? []);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Orders
  getOrders: ({ commit }, payload) => {
    api.getOrders(payload).then((response) => {
      commit('INIT_ORDERS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getOrder: ({ commit }, id) => api.getOrder(id).then((response) => {
    commit('INIT_ORDER', response.data.data);
  }),

  // Messages
  getMessages: ({ commit }, payload) => {
    api.getMessages(payload).then((response) => {
      commit('INIT_MESSAGES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getUnreadMessagesCount: ({ commit }) => {
    api.getUnreadMessagesCount().then((response) => {
      commit('INIT_UNREAD_MESSAGES_COUNT', response.data.data);
    });
  },

  // User files
  getUserFiles: ({ commit }) => {
    api.getUserFiles().then((response) => {
      commit('INIT_USER_FILES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Tags
  getMostPopularTags: ({ commit }) => api.getMostPopularTags().then((response) => {
    commit('INIT_MOST_POPULAR_TAGS', response.data.data);
    return response.data.data;
  }),

  // Complaints
  getComplaints: ({ commit }, payload) => {
    api.getComplaints(payload).then((response) => {
      commit('INIT_COMPLAINTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Parameters
  getFreeShippingAmount: ({ commit }) => {
    api.getFreeShippingAmount().then((response) => {
      commit('INIT_FREE_SHIPPING_AMOUNT', response.data.data);
    });
  },
  getAllowOrderingStockZero: ({ commit }) => {
    api.getAllowOrderingStockZero().then((response) => {
      commit('INIT_ALLOW_ORDERING_STOCK_ZERO', response.data.data);
    });
  },
  getFreeShippingEnabled: ({ commit }) => {
    api.getFreeShippingEnabled().then((response) => {
      commit('INIT_FREE_SHIPPING_ENABLED', response.data.data);
    });
  },
  getUseDefaultLanguage: ({ commit }) => {
    api.getUseDefaultLanguage().then((response) => {
      commit('INIT_USE_DEFAULT_LANGUAGE', response.data.data);
      return response.data.data;
    });
  },
  getDefaultLanguage: ({ commit }) => {
    api.getDefaultLanguage().then((response) => {
      commit('INIT_DEFAULT_LANGUAGE', response.data.data);
      localStorage.setItem('defaultLangId', response.data.data);
      return response.data.data;
    });
  },
  getLanguages: ({ commit }) => {
    api.getLanguages().then((response) => {
      const languages = response.data.data.map((lang) => ({
        id: lang,
        title: lang,
        shortTitle: lang,
      }));
      commit('INIT_LANGUAGES', languages);
    });
  },

  // Modals
  showOutOfStockModal: ({ commit }, payload) => {
    commit('INIT_OUT_OF_STOCK_MODAL', { ...payload, isVisible: true });
  },
  hideOutOfStockModal: ({ commit }) => {
    commit('INIT_OUT_OF_STOCK_MODAL', { isVisible: false });
  },
};
